if (!customElements.get('count-down')) {
    class CountDown extends HTMLElement {
        constructor() {
            super();
            this.countdownVisibility = true;
            this.countdownTimer = this.querySelector('.countdown-timer')
            this.timerInner = this.querySelector('.countdown-timer-inner')
            this.timerVisibility = this.timerInner.dataset.timerVisibility
            
    
            this.countdownSection = this.querySelector('.pesto-countdown-section')
            
            this.message = this.querySelector('.timer-end-message')
    
            this.days = this.querySelector('.id-days')
            this.hours = this.querySelector('.id-hours')
            this.minutes = this.querySelector('.id-minutes')
            this.seconds = this.querySelector('.id-seconds')
    
            this.init()
        }
        init(){
            this.startTimer()
        }
        startTimer(){
        const { day, hour, min, month, year } = this.countdownTimer.dataset
        const timerTime = new Date(year, month, day, hour, min, 0).getTime();
        const timerInterval = setInterval( () => {
        const now = new Date().getTime();
        const distance = timerTime - now;
            if (distance < 0) {
                clearInterval(timerInterval)
                this.message.classList.add("active")
                // this.timerInner.classList.add("d-none")
                // this.timerVisibility === true ? this.timerInner.classList.add("inActive") : ''
                return;
            }
            this.timeTime(distance)
        }, 1000);
        }
        timeTime(distance){
            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((distance % (1000 * 60)) / 1000);
            this.days.textContent = days
            this.hours.textContent = ("0" + hours).slice(-2);
            this.minutes.textContent = ("0" + minutes).slice(-2);
            this.seconds.textContent = ("0" + seconds).slice(-2);
            this.timerInner.classList.add("active")
        }
    }
    customElements.define('count-down', CountDown); 
}